/* eslint-disable no-undef */
import { initScale, destroyScale } from "./resize";
const iframe = document.querySelector(".demo-iframe");
const resIframeContainer = document.querySelector(".demo-iframe-container");

const desktopBtn = document.querySelector(".demo-desktop-btn");
const tabletBtn = document.querySelector(".demo-tablet-btn");
const mobileBtn = document.querySelector(".demo-mobile-btn");

const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

const isMobile = window.matchMedia("(max-width: 767px)");
const isTablet = window.matchMedia("(min-width: 768px) and (max-width: 1024px)");

let currentDevice = "default";
let isTabletDefault = false;

function setActiveDevice(device) {
  currentDevice = device;

  desktopBtn.classList.remove("active");
  tabletBtn.classList.remove("active");
  mobileBtn.classList.remove("active");
  iframe.classList.remove("desktop", "tablet", "mobile");
  resIframeContainer.classList.remove("desktop", "tablet", "mobile");

  if (device === "desktop" || (device === "tablet" && isTabletDefault)) {
    desktopBtn.classList.add("active");
    iframe.classList.add("desktop");
    resIframeContainer.classList.add("desktop");
    destroyScale();
  } else if (device === "tablet") {
    tabletBtn.classList.add("active");
    iframe.classList.add("tablet");
    resIframeContainer.classList.add("tablet");
    destroyScale();
    setTimeout(() => initScale(".demo-iframe-container"));
  } else if (device === "mobile") {
    mobileBtn.classList.add("active");
    iframe.classList.add("mobile");
    resIframeContainer.classList.add("mobile");
    destroyScale();
    setTimeout(() => initScale(".demo-iframe-container"));
  }
}

function setDefaultDeviceOnLoad() {
  isTabletDefault = isTablet.matches && isTouchDevice;
  if (isMobile.matches) {
    setActiveDevice("mobile");
  } else if (isTabletDefault) {
    setActiveDevice("desktop");
  } else {
    setActiveDevice("desktop");
  }
}

function hideUnsupportedButtons() {
  if (isMobile.matches) {
    desktopBtn.style.display = "none";
    tabletBtn.style.display = "none";
    mobileBtn.style.display = "inline-block";
  } else if (isTablet.matches && isTouchDevice) {
    desktopBtn.style.display = "none";
    tabletBtn.style.display = "inline-block";
    mobileBtn.style.display = "inline-block";
  } else {
    desktopBtn.style.display = "inline-block";
    tabletBtn.style.display = "inline-block";
    mobileBtn.style.display = "inline-block";
  }
}

function handleResize() {
  hideUnsupportedButtons();
  isTabletDefault = isTablet.matches && isTouchDevice;

  if (currentDevice === "desktop") {
    return;
  }

  if (currentDevice === "tablet") {
    if (!isMobile.matches) {
      return;
    }
  }

  if (currentDevice === "mobile") {
    return;
  }

  if (isMobile.matches) {
    setActiveDevice("mobile");
  } else if (isTabletDefault) {
    setActiveDevice("desktop");
  } else {
    setActiveDevice("desktop");
  }
}

setDefaultDeviceOnLoad();
hideUnsupportedButtons();
window.addEventListener("resize", handleResize);

desktopBtn.addEventListener("click", () => setActiveDevice("desktop"));
tabletBtn.addEventListener("click", () => setActiveDevice("tablet"));
mobileBtn.addEventListener("click", () => setActiveDevice("mobile"));
